import React, { useState } from "react";
import TextInputLabelHookForm from "../../../../../components/TextInputLabelHookForm";
import { useFormContext } from "react-hook-form";
import { ICameraSystem } from "../types";
import { editStateCameraSystem } from "../atoms/atoms";
import { useRecoilValue } from "recoil";
import CheckBoxLabelHookForm from "components/CheckBoxLabelHookForm";
import { permissionsSelector } from "modules/Login/selectors/permissionSelector";
import { PERMISSIONS } from "modules/PermissionsConstants";

export const CameraSystemDetails = (props: {
  setChanges: React.Dispatch<React.SetStateAction<boolean>>;
  data: ICameraSystem | undefined;
}) => {
  // Props drilled
  const { data, setChanges } = props;

  // Permission
  const userPermissions = useRecoilValue(permissionsSelector);
  const deletePermission = userPermissions.includes(
    PERMISSIONS.permission_utilities_securityconfiguration_camerasystem_delete
  );

  // Recoil Hook
  const edit = useRecoilValue(editStateCameraSystem);

  // Form Functions
  const { register } = useFormContext();
  const formMethods = useFormContext();

  // Local Hooks

  const [inputData, setInputData] = useState(data?.cameraSystemName || "");

  const [checkBoxChanges, setCheckBoxChanges] = useState(data?.isActive);

  return (
    <>
      <div className="bg-bgDB">
        <div className="m-2 bg-white box-shadow h-full">
          <div className="grid grid-cols-4 mx-3 gap-x-6 py-2">
            <div className="col-span-2 my-1">
              <TextInputLabelHookForm
                name="cameraSystemName"
                label="Camera System Name"
                type="text"
                onChange={(e) => {
                  setInputData(e.target.value);

                  if (
                    e.target.value.trim() === "" ||
                    (e.target.value === data?.cameraSystemName &&
                      checkBoxChanges === data?.isActive)
                  ) {
                    setChanges(false);
                  } else {
                    setChanges(true);
                  }
                  e.target.value = e.target.value.replace(/\s+/g, " ");
                }}
                required={true}
                className={
                  formMethods.formState.errors.cameraSystemName &&
                  formMethods.formState.errors.cameraSystemName.message &&
                  "border-2 border-red-500 col-span-2 "
                }
                register={formMethods.register("cameraSystemName", {
                  required: {
                    value: true,
                    message: "Required Field",
                  },
                })}
                maxLength={255}
              />
            </div>

            {edit && (
              <div className="col-span-2 my-1">
                <CheckBoxLabelHookForm
                  name="isActive"
                  label={
                    checkBoxChanges
                      ? "Uncheck to Deactivate"
                      : "Check to Activate"
                  }
                  type="checkbox"
                  onClick={(e) => {
                    if (!deletePermission && data?.isActive) return;

                    setCheckBoxChanges(e.target.checked);

                    if (
                      inputData?.trim() === "" ||
                      (e.target.checked === data?.isActive &&
                        inputData === data?.cameraSystemName)
                    ) {
                      setChanges(false);
                    } else {
                      setChanges(true);
                    }
                  }}
                  disabled={!deletePermission && data?.isActive ? true : false}
                  register={register}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CameraSystemDetails;
